import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WHATSAPP, waLink, handleAnchor } from "../lib/site";
import { Reveal, MaskLines } from "./Reveal";
import { LogoSquare } from "./JLMark";

export const ConversionCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const href = WHATSAPP ? waLink("Olá, JL Nexus! Quero criar o site da minha empresa.") : "#contato";

  return (
    <section ref={ref} id="comecar" data-testid="conversion-section" className="relative px-5 py-16 sm:px-8 sm:py-24">
      <div className="grain relative mx-auto max-w-[1400px] overflow-hidden rounded-[2rem] border border-[#087BFF]/30 bg-[#06122A] px-6 py-16 sm:px-14 sm:py-24">
        <div className="animated-gradient absolute -left-1/4 -top-1/2 h-[140%] w-[80%] rounded-full opacity-30 blur-[120px]" />
        <div className="grid-lines absolute inset-0 opacity-70" />
        <motion.div style={{ y }} className="pointer-events-none absolute right-6 top-[12%] hidden opacity-95 md:block lg:right-16">
          <div className="float-y" style={{ perspective: 900 }}>
            <motion.img src={`${process.env.PUBLIC_URL}/img/logo-square.webp`} alt="Logotipo JL Nexus" className="w-[300px] lg:w-[360px]" animate={{ rotateY: [-12, 12, -12] }} transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }} />
          </div>
        </motion.div>
        <div className="relative max-w-2xl">
          <h2 className="font-display text-3xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskLines inView lines={[<>Vamos transformar</>, <>sua ideia em um</>, <span className="text-grad">site profissional?</span>]} />
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-base text-slate-200 md:text-lg">Conte para nós sobre sua empresa e descubra como uma presença digital bem construída pode valorizar sua marca e aproximar você de novos clientes.</p>
            <a
              href={href}
              {...(WHATSAPP ? { target: "_blank", rel: "noopener noreferrer" } : { onClick: (e) => handleAnchor(e, "contato") })}
              data-testid="conversion-cta-button"
              className="btn-shine group mt-10 inline-flex h-16 items-center gap-3 rounded-full bg-white px-9 text-base font-semibold text-[#080B12] shadow-[0_0_50px_rgba(0,200,255,0.45)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_0_70px_rgba(0,200,255,0.7)]"
            >
              Quero criar meu site
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#087BFF] text-white transition-transform duration-300 group-hover:rotate-45"><ArrowUpRight className="h-5 w-5" /></span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
